// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {
	// Write your JavaScript here
		
		let link = wixWindow.referrer;
        let guts = link.includes("guts")
        let schuld = link.includes("schuld")
        if (guts === true || schuld === true){
			console.log(guts)
			console.log(schuld)

			console.log(link)
        }else{
			console.log('fout')
            wixLocation.to('https://www.schuldofonschuld.nl/ticketmelding')
        }

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});